import { store } from 'App';
import { useIdleTimer } from 'react-idle-timer';
import { authActions } from 'state/auth/auth.actions';
import { useSelector } from 'react-redux';
import { tokenPayloadSelector } from 'state/auth/auth.selectors';
import { TokenPayload } from 'models/token';

export const useTokenExpDetector = () => {
  const tokenPayload = useSelector(tokenPayloadSelector) as TokenPayload;
  const oneMinBeforeTokenExp = tokenPayload.exp - 60;
  const timeToLogout = new Date(oneMinBeforeTokenExp * 1000);

  const onAction = () => {
    //should be refresh token now
    new Date() > timeToLogout && store.dispatch(authActions.logout());
  };

  const { getElapsedTime } = useIdleTimer({
    onAction,
    timeout: 10_000,
    throttle: 500,
  });

  getElapsedTime();

  return {
    onAction,
    getElapsedTime,
  };
};
